import * as React from 'react';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { UIComponentHandler, UIComponentState, UIDataModel } from '../../../toolkit/uicomponent';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import {  NoResultComponentProps } from './noresultcomponent';
import { NoResultCSSStyle } from './noresultcss';
import './noresult-style.css';

export class NoResultViewImpl extends UIComponentViewImpl<UIDataModel>
{
           
    constructor(context:BaseContext, handler:UIComponentHandler)
    {
        super(context,handler);
    }
    bindHandlers()
    {
    }

    draw(props: NoResultComponentProps, state: UIComponentState, cssStyle: NoResultCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <>
              <div id="noresult-web-wrapper">
                  {
                      this.getWebView(props, state, cssStyle)
                  }
              </div>
              <div id="noresult-mobile-wrapper">
                  {
                      this.getMobileView(props, state, cssStyle)
                  }
              </div>
            </>
        );
    }

    
    getWebView(props: NoResultComponentProps, state: UIComponentState, cssStyle: NoResultCSSStyle):JSX.Element
    {
        return(
          <>
                <div style={cssStyle.getWrapperCSSStyle()}>
                <div style={cssStyle.getInnerWrapperCSSStyle()}>
                    {/* <div style={{width:'863px',height:'60px',display:'flex',alignItems:'center'}}>
                            <SearchBoxComponent  context={props.context}  searchKey={props.searchKey} onSearchBoxButtonClicked={(e)=>this.onSearchClick(props.searchKey)} cssStyle={this.searchCSSStyle}/>
                            <div style={{width:'63px',height:'100%',alignItems:'center',paddingTop:'10px',paddingLeft:'15px'}}>
                                    < img onClick={this.clearData} style={{width:'30px',height:'30px'}} src={this.getContext().getResources().getImage("close.svg")}/>
                            </div>
    
                     </div> */}
                     <div style={cssStyle.getImageDivCSSStyle()}>
                            <img width='246px' height='177px' src={this.getContext().getResources().getImage('noresult.svg')}/>
                     </div>
                     <label style={cssStyle.getNoResultLabelCSSStyle()}>
                         {this.getContext().getResources().getString(Strings.no_result)}
                     </label>
                     <label style={cssStyle.getNoResultContentCSSStyle()}>
                     {this.getContext().getResources().getString(Strings.no_result_msg)}
                     </label>
                    {/* <div style={{width:'32%',height:'42px',justifyItems:'center',margin:'auto'}}>
                        <div style={cssStyle.getInputDivCSSStyle()}>
                            <TextComponent label={''} placeholder={"Confirm name to set as name tunes"}  isDisabled={false} ref={(item: any) => this.textComponent = item} id={"#tunename"} value={''} inputType={"text"} isRequired={true}  context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.tunenameerrormsg)}/> 

                            </div>
                    </div>  */}
                        
                      
                </div>
                  
                 
            </div>
          </>  
        );
    }

    getMobileView(props: NoResultComponentProps, state: UIComponentState, cssStyle: NoResultCSSStyle):JSX.Element
    {
        return(
            <>
                 <div style={cssStyle.getWrapperCSSStyle()}>
                <div style={cssStyle.getInnerWrapperCSSStyle()}>
                    {/* <div style={{width:'863px',height:'60px',display:'flex',alignItems:'center'}}>
                            <SearchBoxComponent  context={props.context}  searchKey={props.searchKey} onSearchBoxButtonClicked={(e)=>this.onSearchClick(props.searchKey)} cssStyle={this.searchCSSStyle}/>
                            <div style={{width:'63px',height:'100%',alignItems:'center',paddingTop:'10px',paddingLeft:'15px'}}>
                                    < img onClick={this.clearData} style={{width:'30px',height:'30px'}} src={this.getContext().getResources().getImage("close.svg")}/>
                            </div>
    
                     </div> */}
                     <div style={cssStyle.getMobileImageDivCSSStyle()}>
                            <img width='123px' height='87px' src={this.getContext().getResources().getImage('noresult.svg')}/>
                     </div>
                     <label style={cssStyle.getMobileNoResultLabelCSSStyle()}>
                         {this.getContext().getResources().getString(Strings.no_result)}
                     </label>
                     <label style={cssStyle.getMobileNoResultContentCSSStyle()}>
                     {this.getContext().getResources().getString(Strings.no_result_msg)}
                     </label>
                    {/* <div style={{width:'32%',height:'42px',justifyItems:'center',margin:'auto'}}>
                        <div style={cssStyle.getInputDivCSSStyle()}>
                            <TextComponent label={''} placeholder={"Confirm name to set as name tunes"}  isDisabled={false} ref={(item: any) => this.textComponent = item} id={"#tunename"} value={''} inputType={"text"} isRequired={true}  context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.tunenameerrormsg)}/> 

                            </div>
                    </div>  */}
                        
                      
                </div>
                  
                 
            </div>
            </>
        );
    }

    
    // onSearchClick(searchKey:string):void
    // {
    //     (this.getUIComponentHandler() as NoResultComponentHandler).onSearchClicked(searchKey);
    // }
     
    // onRequestNowClick():void
    // {
    //     (this.getUIComponentHandler() as NoResultComponentHandler).onRequestNow();

    // }
    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/nametunes/noresult/noresultview.tsx